(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-collections__header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.parentNode;
      const isOpen = item.classList.contains('active');
      
      // Close all accordion items
      document.querySelectorAll('.accordion-collections__item').forEach(el => {
        el.classList.remove('active');
      });
      
      // Open the clicked one if it was closed
      if (!isOpen) {
        item.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
